module.exports = __webpack_public_path__ + "static/media/logo_v2019.a898717b.png";